import type { Group } from './types';

export const createGroupLabel = (group: Group) => (group.email ? `${group.name} (${group.email})` : `${group.name}`);
